<template>
    <ion-page>
        <ion-header>
            <ion-toolbar>
                <ion-buttons slot="end">
                    <ion-button @click="close()">
                        <ion-icon slot="icon-only" :icon="closeOutline"></ion-icon>
                    </ion-button>
                </ion-buttons>
                <ion-title>{{ shipment.reference }}</ion-title>
            </ion-toolbar>
        </ion-header>
        <ion-content :fullscreen="true">
            <ion-searchbar @keypress.enter="doSearch($event.target.value)" animated mode="ios"  />
            <ion-item color="tertiary">
                Box Group: Boxes {{ boxNumbers[0] }} - {{ boxNumbers[boxNumbers.length -1] }}
            </ion-item>
            <ion-list v-for="box in boxData" :key="box.id">
                <ion-item>
                    <ion-label><strong>Box {{ box.number }}</strong></ion-label>
                </ion-item>
                <div v-for="item in box.items" :key="item.line.id">
                    <ion-item>
                        <ion-label class="ion-text-wrap">
                            <h2>{{ item.quantity }} x {{ item.line.item.item_number }} - <em>{{ item.line.sku.name }}</em> (SKU:{{ item.line.sku.sku }}) </h2>
                            <ion-text color="danger" v-if="item.line.packing_instructions"><p>{{ item.line.packing_instructions }}</p></ion-text>
                            <ion-text color="warning" v-if="likelySubstitute(item.line)">{{ substituteInformation(item.line) }}</ion-text>
                        </ion-label>
                    </ion-item>
                    <ion-item v-for="line in getShipmentLineChildren(item.line)" :key="line.id">
                        <ion-icon :icon="returnDownForwardOutline" class="child-line-item"/>
                        <ion-label class="ion-text-wrap">
                            <h2>{{ line.qty_checked }} x {{ line.sku.name }} ({{ line.sku.sku }}) </h2>
                        </ion-label>
                    </ion-item>
                </div>
            </ion-list>
        </ion-content>
        <ion-footer>
            <ion-button fill="outline" expand="block" color="success" @click="markDone()">Mark {{ boxNumbers.length }} box{{ boxNumbers.length !== 1?'es':''}} as packed</ion-button>
        </ion-footer>
    </ion-page>
</template>

<script>
import {modalController} from '@ionic/vue';
import {
    IonContent, IonPage, IonLabel, IonItem, IonHeader, IonFooter,
    IonToolbar, IonTitle, IonList, IonButtons, IonButton, IonText, IonIcon,
    IonSearchbar
} from '@ionic/vue';

import EventBus from "@/EventBus";
import {closeOutline, checkmarkCircle, returnDownForwardOutline} from 'ionicons/icons';
import _ from "lodash";

export default {
    props: ['shipment', 'boxes'],
    inject: ['$http', '$toast', '$validationAlert', '$scanner'],
    name: 'PickLineModal',
    components: {
        IonContent, IonPage, IonLabel, IonItem, IonHeader, IonText,
        IonToolbar, IonTitle, IonList, IonButtons,
        IonButton, IonIcon, IonFooter, IonSearchbar
    },
    computed: {
        boxNumbers() {
            // https://stackoverflow.com/a/1063027 for sorting workaround
            return _.chain(this.boxes).map('number').sort((a, b) => a - b).value();
        },
        concatBoxIds() {
            return _.map(this.boxes, 'id').join(',');
        },
        include() {
            return 'items,items.line,items.line.sku,items.line.sku.item,items.line.item';
        }
    },
    mounted() {
        this.refresh();
    },
    data() {
        return {
            search: '',
            boxData: []
        }
    },
    methods: {
        likelySubstitute(item) {
            return (item.sku?.item?.id !== item?.item?.id);
        },
        substituteInformation(item) {
            console.log(item);
            return `Looks like original '${item.sku.item.item_number}' has been substituted for '${item.item.item_number}'`;
        },
        refresh() {
            EventBus().emitter.emit('loading', true);
            this.$http.get(`/api/packs/shipments/${this.shipment.id}/boxes/${this.concatBoxIds}`, {
                params: {
                    include: this.include,
                    search: this.search
                }
            }).then(response => {
                this.boxData = response.data.items;
            }).finally(() => {
                EventBus().emitter.emit('loading', false);
            });
        },
        doSearch(search) {
            this.search = search;
            this.refresh();
        },
        getShipmentLineChildren(line) {
            return _.filter(this.shipment.lines, {parent_line_id: line.id});
        },
        close() {
            modalController.dismiss();
        },
        /**
         * @param box
         */
        markDone() {
            EventBus().emitter.emit('loading', true);
            // send through a payload which contains: picked (count),
            // reason (object with id as a key), comment (string)
            this.$http.put(`/api/packs/shipments/${this.shipment.id}/boxes/${this.concatBoxIds}`, {
                packed: true
            }).then( () => {
                this.$toast.success('Box marked as done');
                modalController.dismiss(true);
                EventBus().emitter.emit('loading', false);
            }).catch(error => {
                EventBus().emitter.emit('loading', false);
                this.$validationAlert(error);
            });
        }
    },
    setup() {
        return {
            returnDownForwardOutline,
            checkmarkCircle,
            closeOutline
        };
    }
}
</script>
<style scoped>
    .child-line-item {
        margin-right: 16px;
    }
    ion-footer {
        background-color: var(--ion-background-color, #fff);
    }
</style>
